let activeDialog = null;
let activeMenu = null;
let listeners = [];

export function setActiveDialog(dialogName) {
    activeDialog = dialogName;
    notifyListeners();
}

export function setActiveMenu(menuName) {
    activeMenu = menuName;
    notifyListeners();
}

export function getActiveDialog() {
    return activeDialog;
}

export function getActiveMenu() {
    return activeMenu;
}

export function isDialogActive(dialogName) {
    return activeDialog === dialogName;
}

export function isMenuActive(menuName) {
    return activeMenu === menuName;
}

export function onStateChange(callback) {
    listeners.push(callback);
    return () => {
        listeners = listeners.filter(l => l !== callback);
    };
}

function notifyListeners() {
    listeners.forEach(cb => cb({ dialog: activeDialog, menu: activeMenu }));
}